import { render, staticRenderFns } from "./AssetComponentWithoutStore.vue?vue&type=template&id=70aaeb56&"
import script from "./AssetComponentWithoutStore.vue?vue&type=script&lang=js&"
export * from "./AssetComponentWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports